import React, { useRef, useState } from "react";
import {
    Badge,
    Button,
    Col,
    Container,
    NavDropdown,
    Row,
    Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { useEffect } from "react";
import { commonService } from "../../utils/commonService";
import { Chart } from "chart.js/auto";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import Loader from "../Loader/Loader";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const PriceQualityInsights = ({ api, para, setting }) => {

    let DummyData = [
        {
            "AsOfDate": "1900-01-01",
            "CompetitorID": 1,
            "avg_rate": 83.86,
            "IsSelf": true,
            "competiterpropertyname": "Comfort Inn Festus-St Louis South",
            "rating": 5,
            "ratingfrom": "Google",
            "ratedate": "1900-01-01"
        },
        {
            "AsOfDate": "1900-01-01",
            "CompetitorID": 2,
            "avg_rate": 144.35,
            "IsSelf": false,
            "competiterpropertyname": "Holiday Inn Express Hotel & Suites FESTUS - SOUTH ST. LOUIS, an IHG Hotel",
            "rating": 4.5,
            "ratingfrom": "Google",
            "ratedate": "1900-01-01"
        },
        {
            "AsOfDate": "1900-01-01",
            "CompetitorID": 3,
            "avg_rate": 79.55,
            "IsSelf": false,
            "competiterpropertyname": "Quality Inn Festus",
            "rating": 1,
            "ratingfrom": "Google",
            "ratedate": "1900-01-01"
        },
        {
            "AsOfDate": "1900-01-01",
            "CompetitorID": 4,
            "avg_rate": 74.83,
            "IsSelf": false,
            "competiterpropertyname": "Super 8 by Wyndham Pevely",
            "rating": 3.5,
            "ratingfrom": "Google",
            "ratedate": "1900-01-01"
        },
        {
            "AsOfDate": "1900-01-01",
            "CompetitorID": 5,
            "avg_rate": 124.46,
            "IsSelf": false,
            "competiterpropertyname": "La Quinta by Wyndham Festus - St. Louis South",
            "rating": 2,
            "ratingfrom": "Google",
            "ratedate": "1900-01-01"
        }
    ]

    const [loading, setLoading] = useState(false);
    const [IsDataFound, setIsDataFound] = useState(false);
    const [ChartData, setChartData] = useState(false);

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
    const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

    const [chart_y_axis_value, setchart_y_axis_value] = useState(100);
    const [chart_x_axis_value, setchart_x_axis_value] = useState(200);

    const getpricing_vs_quality = async () => {
        if (api === 0) return;
        setLoading(true)
        let pricing_vs_qualityResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICE_QUALITY_INSIGHTS.PRICE_QUALITY_INSIGHTS,
                body: {
                    "propertyCode": propertyCode
                },
            },
            false
        );

        let response = apiResponse(false, pricing_vs_qualityResponse);

        if (response?.isValidate) {
            setIsDataFound(true)
            setChartData(response?.data?.data)
            /*setChartData(DummyData)*/

        }

        if (!response?.isValidate) {
            setIsDataFound(false)
            setChartData([])
        }
        setLoading(false)
    };



    useEffect(() => {
        if (api === 0) return;
        if (IsDataFound && ChartData?.length > 0) {

            let maxRating = ChartData.reduce((max, item) => item.rating > max ? item.rating : max, -Infinity);
            let maxAvgRate = ChartData.reduce((max, item) => item.avg_rate > max ? item.avg_rate : max, -Infinity);
            maxRating = Math.ceil(maxRating / 5) * 5
            maxAvgRate = Math.ceil(maxAvgRate / 10) * 10
            maxAvgRate = (Math.ceil((maxAvgRate / 10) / 2) * 10) * 2;

            let datasets = [];

            ChartData.map((item) => {
                datasets.push({
                    label: item.competiterpropertyname,
                    data: [{
                        x: Math.round(item.avg_rate),
                        y: item.rating ? item.rating : 0,
                        r: Math.sqrt(item.rating * Math.round(maxAvgRate > 1000 ? item.avg_rate / 100 : item.avg_rate) * 2),
                        aod: commonService.getDateInFormat(item.AsOfDate),
                        rd: commonService.getDateInFormat(item.ratedate),
                        rf: item.ratingfrom ? item.ratingfrom : "",
                        cn: item.competiterpropertyname ? item.competiterpropertyname : ""
                    }],
                    backgroundColor: commonService.CreateColor(item.competiterpropertyname).BGColor,
                    borderColor: commonService.CreateColor(item.competiterpropertyname).BGColor,
                    borderWidth: 1,
                    pointStyle: item.IsSelf ? 'rectRot' : 'circle',
                })
            })

            const quadrants = {
                id: "quadrants",
                beforeDraw(chart, args, options) {
                    const {
                        ctx,
                        chartArea: { left, top, right, bottom },
                        scales: { x, y },
                    } = chart;
                    ctx.save();
                    ctx.font = "bold 12px Arial";
                    ctx.fillStyle = "rgba(0, 0, 0, 0.55)";

                    ctx.fillText(
                        "Low Price",
                        left,
                        top
                    );

                    ctx.fillText(
                        "High Quality",
                        left,
                        top + 15
                    );

                    ctx.fillText(
                        "High Price",
                        right - 60,
                        top
                    );

                    ctx.fillText(
                        "High Quality",
                        right - 60,
                        top + 15
                    );

                    ctx.fillText(
                        "Low Price",
                        left,
                        bottom - 15
                    );

                    ctx.fillText(
                        "Low Quality",
                        left,
                        bottom
                    );


                    ctx.fillText(
                        "High Price",
                        right - 60,
                        bottom - 15
                    );

                    ctx.fillText(
                        "Low Quality",
                        right - 60,
                        bottom
                    );

                    ctx.restore();
                },
            };

            var ctx = document?.getElementById("price_quality_insights_chart");
            if (ctx) {
                var myChart = new Chart(ctx, {
                    type: "bubble",
                    data: {
                        datasets: datasets,
                    },
                    plugins: [quadrants],
                    options: {
                        scales: {
                            x: {
                                position: 'center',
                                title: {
                                    display: false,
                                    text: "Price",
                                },
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: function (context) {
                                        if (context.tick.value === (maxAvgRate / 2)) {
                                            return "#000000";
                                        } else {
                                            return "";
                                        }
                                    },
                                },
                                suggestedMin: 0,
                                suggestedMax: maxAvgRate,
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 10,
                                    callback: function (value) {
                                        return `${propertyDetailFromRTK?.currency_term
                                            ? propertyDetailFromRTK?.currency_term
                                            : "$"
                                            }${value}`;
                                    },
                                },
                            },
                            y: {
                                position: 'center',
                                title: {
                                    display: false,
                                    text: "Quality",
                                },
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: function (context) {
                                        if (context.tick.value === (maxRating / 2)) {
                                            return "#000000";
                                        } else {
                                            return "";
                                        }
                                    },
                                },
                                suggestedMin: 0,
                                suggestedMax: maxRating,
                                ticks: {
                                    stepSize: 0.5,
                                    callback: function (value) {
                                        return `${value}`;
                                    },
                                },
                            },
                        },
                        responsive: true,
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        var rating = context.raw.y;
                                        var avg_rate = context.raw.x;
                                        var asofdate = context.raw.aod;
                                        var ratedate = context.raw.rd;
                                        /*var ratingfrom = context.raw.rf;*/
                                        var comname = context.raw.cn;
                                        return `The hotel ${comname} average rate as of ${asofdate} is ${commonService.formateAmount(avg_rate)}, while the rating as of ${ratedate} is ${rating}.`;
                                    },
                                },
                            },
                            legend: {
                                position: "bottom",
                            },
                        },
                    },
                });

                return () => {
                    myChart.destroy();
                };
            }
        }
    }, [IsDataFound, ChartData]);

    useEffect(() => {
        if (api === 0) return;
        if (propertyCode) {
            getpricing_vs_quality();
        }
    }, [propertyCode, api]);

    return (
        <div className="RmBusinessIntMain">
            {propertyCode ? (
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3 Configflexcolum">
                            <div className="ProspectDashboardTitleWraper">
                                <h2>
                                    Dashboard -{" "}
                                    <span className="tab-title-main">Price-Quality Insights</span>
                                </h2>
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        {loading ? (
                            <Loader />
                        ) : IsDataFound ? (
                            <canvas id="price_quality_insights_chart"></canvas>
                        ) : (
                            <div style={{ textAlign: "center" }}>
                                <p>No Data Found</p>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
            ) : (
                <Container fluid>
                    <div className="d-flex justify-content-center p-5">
                        <h5>Please Select Property</h5>
                    </div>
                </Container>
            )}
        </div>
    );
};

export default PriceQualityInsights;
